<template>
    <Office></Office>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../../Layouts/AuthLayout.vue")
);
const Office = defineAsyncComponent(() =>
    import("../../../components/ITDepartment/RemoteWorking/Office.vue")
);

export default {
    name: "Office_365_&_Email", //The name you are in should not equal the name of the component you are importing.
    components: { Office, AuthLayout },
};
</script>
